import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SearchFilters from "./SearchFilters";
import { filterNames, filterValues, isoCountries } from "../../constants";
import Filter from "./Filter";
import { uniqueId } from "lodash";
import { useLocation } from "react-router-dom";

const PlatformWithText = ({ path, size, platformName }) => {
  return (
    <span>
      <img
        src={require(`@src/assets/images/vyrill/${path}`).default}
        width={size}
        style={{ marginLeft: "6px", marginRight: "5px", marginBottom: "4px" }}
      />{" "}
      {platformName}
    </span>
  );
};

const platformIcons = {
  Campaign: (
    <PlatformWithText
      path="icons/campaign_icon.png"
      size={18}
      platformName="Campaign"
    />
  ),
  // Vyrill_AWS_S3: (
  //   <PlatformWithText
  //     path="icons/campaign_icon.png"
  //     size={18}
  //     platformName="Campaign"
  //   />
  // ),
  Youtube: (
    <PlatformWithText
      path="icons/youtube_icon.png"
      size={18}
      platformName="YouTube"
    />
  ),
  Tiktok: (
    <PlatformWithText
      path="icons/tiktok_icon.png"
      size={18}
      platformName="TikTok"
    />
  ),
  Dropbox: (
    <PlatformWithText
      path="icons/dropbox_icon.png"
      size={18}
      platformName="Dropbox"
    />
  ),
  GoogleDrive: (
    <PlatformWithText
      path="icons/google_drive_icon.png"
      size={18}
      platformName="Google Drive"
    />
  ),
  Instagram: (
    <PlatformWithText
      path="icons/instagram_icon.png"
      size={18}
      platformName="Instagram"
    />
  ),
};

const FilterOptions = ({
  filters,
  selectedFilters,
  updateFilters,
  updateSubFilters,
  updateParentTopics,
  name,
  showIndicators,
  topicFilters,
}) => {
  const [topicsOpenedFilters, setTopicsOpenedFilters] = useState([]);
  const campaigns = useSelector((state) => state.videoPageStates.campaigns);
  const [showCampaigns, setShowCampaigns] = useState(false);
  // const showCampaignHeader = useSelector(
  //   (state) => state.videoPageStates.campaignsState.showCampaignHeader
  // );
  const tabData = useSelector((state) => state.reports.tab.tab);

  const renderCampaignFilter = () => (
    <div className="filter" key="Campaign">
      <label key="Campaign">
        <input
          type="checkbox"
          checked={showCampaigns}
          value={`Campaign`}
          onChange={
            showCampaigns
              ? () => {
                  updateFilters; // Call the updateFilters method
                  setShowCampaigns(false); // Set showCampaigns to false after update
                }
              : (e) => setShowCampaigns(e.target.checked)
          }
        />
        {showIndicators && (
          <div className={`sponsored-indicator ${"campaign".toLowerCase()}`} />
        )}
        <span>{platformIcons["Campaign"]}</span>
      </label>
      {showCampaigns && (
        <div className="filter campaign">
          {campaigns?.map((filter) => (
            <label key={uniqueId()}>
              <input
                type="checkbox"
                value={`Campaign-${filter?._id}`}
                checked={
                  selectedFilters &&
                  Array.isArray(selectedFilters) &&
                  selectedFilters.includes(`Campaign-${filter?._id}`)
                }
                onChange={updateFilters}
              />{" "}
              {showIndicators && (
                <div
                  className={`sponsored-indicator ${filter?.name?.toLowerCase()}`}
                />
              )}
              <span>{filter?.name}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );

  if (selectedFilters?.radio) {
    if (filters?.radio) return null;
    return (
      <div>
        {filters.map((filter) => (
          <label key={filter} className="filter">
            <input
              type="checkbox"
              value={filter}
              checked={filter === selectedFilters.value}
              onChange={updateFilters}
            />{" "}
            <span>
              {name == "platform"
                ? platformIcons[filter]
                : isNaN(filter)
                ? filterValues[filter] || filter
                : `${filter?.toLocaleString()}+`}
            </span>
          </label>
        ))}
      </div>
    );
  }

  if (name === "topic" || name === "video_type") {
    return (
      <div>
        {filters &&
          typeof filters === "object" &&
          Object.keys(filters).map((key) => (
            <Filter
              key={key}
              filters={filters[key]}
              selectedFilters={selectedFilters || []}
              updateParentTopics={updateParentTopics}
              updateFilters={updateFilters}
              name={filterNames[key] || key}
              subFilter={false}
              closeFilters={() => {
                setTopicsOpenedFilters((prev) => prev.filter((i) => i !== key));
              }}
              openFilter={() => {
                setTopicsOpenedFilters([...topicsOpenedFilters, key]);
              }}
              isTopic
              open={topicsOpenedFilters.includes(key)}
              showIndicators={key === "sponsorship"}
              topicFilters={topicFilters}
            />
          ))}
      </div>
    );
  }

  if (selectedFilters?.subTopics) {
    return filters.map((filter) => (
      <label key={filter} className="filter">
        <input
          type="checkbox"
          value={filter}
          checked={
            selectedFilters &&
            selectedFilters.subTopics &&
            selectedFilters.subTopics.includes(filter)
          }
          onChange={updateFilters}
        />{" "}
        {showIndicators && (
          <div className={`sponsored-indicator ${filter.toLowerCase()}`} />
        )}
        <span>{filterValues[filter] || filter}</span>
      </label>
    ));
  }

  if (name === "brand") {
    return (
      <div>
        {filters.map((filter) => (
          <label key={filter} className="filter">
            <input
              type="checkbox"
              value={filter}
              checked={selectedFilters.includes(filter)}
              onChange={updateFilters}
            />{" "}
            {showIndicators && (
              <div className={`sponsored-indicator ${filter.toLowerCase()}`} />
            )}
            <span>{filter}</span>
          </label>
        ))}
      </div>
    );
  }

  if (Array.isArray(filters)) {
    const campaignFilter = filters.find((filter) => filter === "Campaign");
    const otherFilters = filters.filter((filter) => filter !== "Campaign");
    return (
      <div>
        {campaignFilter && renderCampaignFilter()}
        {otherFilters && otherFilters.length > 10 ? (
          <SearchFilters
            filters={otherFilters}
            selectedFilters={selectedFilters}
            updateFilters={updateFilters}
            name={name}
          />
        ) : (
          otherFilters.map((filter) => (
            <div className="filter" key={filter}>
              <label key={filter}>
                <input
                  type="checkbox"
                  value={filter}
                  checked={
                    selectedFilters &&
                    Array.isArray(selectedFilters) &&
                    selectedFilters.includes(filter)
                  }
                  onChange={updateFilters}
                />{" "}
                {showIndicators && (
                  <div
                    className={`sponsored-indicator ${filter.toLowerCase()}`}
                  />
                )}
                <span>
                  {name == "platform"
                    ? platformIcons[filter]
                    : filterValues[filter] || isoCountries[filter] || filter}
                </span>
              </label>
            </div>
          ))
        )}
        {/* {!showCampaignHeader && campaignFilter && renderCampaignFilter()} */}
      </div>
    );
  }

  if (filters && typeof filters === "object") {
    return (
      <div>
        {Object.keys(filters).map((key) => (
          <Filter
            key={key}
            filters={filters[key]}
            selectedFilters={selectedFilters[key] || []}
            updateFilters={updateSubFilters(key)}
            name={filterNames[key] || key}
            subFilter
            isTopic={false}
            open
            showIndicators={key === "sponsorship"}
            topicFilters={topicFilters}
          />
        ))}
      </div>
    );
  }

  return null;
};

export default FilterOptions;
